import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xcHp6OXJjMCB7CiAgcG9zaXRpb246IGFic29sdXRlOwogIGRpc3BsYXk6IG5vbmU7Cn0';
export var popperStyle = '_1pzz9rc0';